import { CheckboxValueSchema, ICheckboxValue } from '@dokucoach/common-types';
import * as yup from 'yup';

export const PainAssessmentSchema = yup.object({
  measurementDate: yup.date().required(),
  personCannotExpressVerbally: yup.boolean().notRequired().default(false),
  painIntensityInRest: yup.string().required(),
  abnormalitiesAtRest: CheckboxValueSchema,
  painIntensityUnderStress: yup.string().required(),
  abnormalitiesUnderStress: CheckboxValueSchema,
  painfulStable: yup.boolean().notRequired().default(false),
  measuresTaken: yup.string().notRequired().nullable(),
});

export interface IPainAssessment {
  measurementDate: Date;
  personCannotExpressVerbally?: boolean;
  painIntensityInRest: string;
  abnormalitiesAtRest?: ICheckboxValue;
  painIntensityUnderStress: string;
  abnormalitiesUnderStress?: ICheckboxValue;
  painfulStable?: boolean;
  measuresTaken?: string;
}

export const CreatePainAssessmentSchema = yup
  .object({
    residentId: yup.string().required(),
  })
  .concat(PainAssessmentSchema);

export interface ICreatePainAssessment extends IPainAssessment {
  residentId: string;
}

export const UpdatePainAssessmentSchema = yup
  .object({
    id: yup.string().required(),
  })
  .concat(PainAssessmentSchema);

export interface IUpdatePainAssessment {
  id: string;
}
